import { render, staticRenderFns } from "./UserBar.vue?vue&type=template&id=73591b35&scoped=true&"
import script from "./UserBar.vue?vue&type=script&lang=js&"
export * from "./UserBar.vue?vue&type=script&lang=js&"
import style0 from "./UserBar.vue?vue&type=style&index=0&id=73591b35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73591b35",
  null
  
)

export default component.exports